// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3f3aa104","732":"90125ca9","977":"d98007d7"}[chunkId] + ".chunk.js";
};